import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

import { User } from '../../_models';
import { UserService, AuthenticationService, NotificationService } from '../../_services';

@Component({ templateUrl: 'profile.component.html' })
export class ProfileComponent implements OnInit {

  currentUser: User;
  form: FormGroup;
  processing = false;
  showError = false;

  constructor(private fb: FormBuilder,
    private userService: UserService,
    private authSvc: AuthenticationService,
    private notification: NotificationService) {

    this.currentUser = this.authSvc.currentUserValue;
  }

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm(): void {
    this.form = this.fb.group({
      oldPassword: ['', Validators.required],
      newPassword: ['', [Validators.required, Validators.minLength(5)]]
    });
  }

  get f() { return this.form.controls; }

  onSubmit() {
    this.processing = true;
    var pwParam = this.form.getRawValue();
    if (this.form.valid) {
      if (confirm("Are you sure to change password?")) {
        this.userService.changeManagerPassword(pwParam).subscribe(data => {
          if (data.status == undefined) {
            this.notification.showSuccess("Password changed successfully!", "Change Password");
            this.showError = false;
            this.form.reset();
          } else {
            this.notification.showError(data.msg, "Update failed");
          }
        })
      }
      this.processing = false;
    } else {
      this.showError = true;
      this.processing = false;
    }
  }

}
